import Translation from '../../Shared/components/Translation';
import React from 'react';
import { renderToString } from 'react-dom/server';
const UnitFormatService = {
    formatHouseNumberAndAddition: (houseNumber, houseNumberAddition = null) => {
        if (!houseNumberAddition) {
            return houseNumber;
        }
        const filterHyphen = (subject) => {
            return subject.charAt(0) === '-' ? subject.substring(1) : subject;
        };
        return houseNumber + '-' + filterHyphen(houseNumberAddition.toUpperCase());
    },
    getPrice: (unit) => {
        if (unit.is_advertised && unit.net_rent) {
            return (unit.net_rent.toLocaleString('nl-NL', { currency: 'EUR', style: 'currency' }) +
                ' ' +
                unit.rent_condition.replace('&sup2;', '²'));
        }
        if (unit.rent) {
            return (unit.rent.toLocaleString('nl-NL', { currency: 'EUR', style: 'currency' }) +
                ' ' +
                unit.rent_condition.replace('&sup2;', '²'));
        }
        if (unit.selling_price) {
            return (unit.selling_price.toLocaleString('nl-NL', {
                currency: 'EUR',
                style: 'currency',
                maximumFractionDigits: 0,
            }) + (unit.buyer_pays_costs ? ' k.k.' : ''));
        }
    },
    getPriceIncl: (unit) => {
        if (unit.is_advertised && unit.gross_rent) {
            return (renderToString(React.createElement(Translation, { item: "tx_zigrealestate.list.grossRent", asString: true })) +
                ' ' +
                unit.gross_rent.toLocaleString('nl-NL', { currency: 'EUR', style: 'currency' }) +
                ' ' +
                unit.rent_condition.replace('&sup2;', '²'));
        }
    },
};
export default UnitFormatService;
